package com.rainbowclubs.rainbow.data.models

import kotlinx.serialization.Serializable

@Serializable
data class HomeResponse(
    val user: User,
    val club: Club,
    val membership: Membership?,
    val upcomingEvent: Event?,
    val ongoingEvent: Event?,
)
